const IGNORED_BROWSER_REJECTION_PATTERNS = [
  /Object Not Found Matching Id:\s*\d+,\s*MethodName:\s*update,\s*ParamCount:\s*\d+/i,
];

interface ClientSentryEvent {
  message?: string;
  exception?: {
    values?: Array<{
      type?: string;
      value?: string;
    }>;
  };
}

interface ClientSentryEventHint {
  originalException?: unknown;
  syntheticException?: unknown;
}

function stringifyUnknown(value: unknown): string {
  if (typeof value === 'string') return value;
  if (value instanceof Error) return `${value.name}: ${value.message}`;
  if (value === null || value === undefined) return '';

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function eventText(
  event: ClientSentryEvent,
  hint?: ClientSentryEventHint
): string {
  const exceptionText =
    event.exception?.values
      ?.map((value) => `${value.type ?? ''}: ${value.value ?? ''}`)
      .join('\n') ?? '';

  return [
    event.message,
    exceptionText,
    stringifyUnknown(hint?.originalException),
    stringifyUnknown(hint?.syntheticException),
  ]
    .filter(Boolean)
    .join('\n');
}

export function isIgnoredClientSentryEvent(
  event: ClientSentryEvent,
  hint?: ClientSentryEventHint
): boolean {
  const text = eventText(event, hint);
  return IGNORED_BROWSER_REJECTION_PATTERNS.some((pattern) =>
    pattern.test(text)
  );
}

export function beforeSendClientEvent<TEvent extends ClientSentryEvent>(
  event: TEvent,
  hint?: ClientSentryEventHint
): TEvent | null {
  if (isIgnoredClientSentryEvent(event, hint)) {
    return null;
  }

  return event;
}
